import {
    Component,
    ElementRef,
    Inject,
    Input,
    LOCALE_ID,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {
    fadeInLeftOnEnterAnimation,
    fadeInOnEnterAnimation,
    fadeInUpBigOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation,
    headShakeAnimation,
} from 'angular-animations';
import {UserService} from '../../../services/user.service';
import {Subscription} from 'rxjs';
import {EventsService} from '../../../services/events.service';
import {ProgressService} from '../../../services/progress.service';
import {environment} from '../../../../environments/environment';
import {AnalyticsService} from '../../../services/analytics.service';
import {CoachModel, TemplateCoachModel, TemplateSessionTitleModel} from '../models/coach.model';
import {
    AlertController,
    ModalController,
    NavController, Platform,
} from '@ionic/angular';
import {CoachService} from '../service/coach.service';
import {CoachAvailabilityModel} from '../models/availability.model';
import {CalendarComponent} from 'ionic2-calendar';
import {formatDate} from '@angular/common';
import {title} from 'process';
import {TranslateService} from '@ngx-translate/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastService} from '../../../services/toast.service';
import {CalendarMode} from 'ionic2-calendar/calendar';

@Component({
    selector: 'app-coach-calendar-page',
    templateUrl: 'coach-calendar.page.html',
    styleUrls: ['coach-calendar.page.scss'],
    animations: [
        fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
        fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
        fadeInUpBigOnEnterAnimation({anchor: 'enterUp', duration: 300}),
        headShakeAnimation(),
    ],
})
export class CoachCalendarPage implements OnInit, OnDestroy {
    subscriptions: Subscription[] = [];
    eventSource = [];
    viewTitle: string;

    environment = null;
    menuVisible = true;

    template_coach_id = 0;
    template_title_id = 0;

    currentMonth = new Date().getMonth() + 1;
    currentYear = new Date().getFullYear();

    currentRange = null
    currentTime = null;

    coach: TemplateCoachModel = null;
    coachPromise: Promise<TemplateCoachModel> = null;
    coachValid = false;

    availability: CoachAvailabilityModel[] = null;
    availabilityPromise: Promise<CoachAvailabilityModel[]> = null;
    availabilityValid = false;

    slotsCount = 1;
    selectedTitle = null;
    selectedType = null;
    availableTypes = [{code: 'video', title: '__CALENDAR_MEETING_TYPE_VIDEO__'},
        {code: 'face2face', title: '__CALENDAR_MEETING_TYPE_FACE2FACE__'}];
    pickedTime = null;
    confirmedTime: CoachAvailabilityModel = null;
    currentDateEvent = [];
    modalIsVisible = false;
    modalCount = 0;
    profileForm: FormGroup = null;

    chosenTitle = '';
    public animationState = false;
    calendar = {
        mode: 'month' as CalendarMode,
        currentDate: new Date(),
    };

    selectedDate: Date;
    lockSwipeToPrev = true;
    lockSwipes = true;
    platform = 'website';

    @ViewChild(CalendarComponent) myCal: CalendarComponent;

    constructor(
        private event: EventsService,
        public authService: AuthService,
        public userService: UserService,
        private analytics: AnalyticsService,
        private coachService: CoachService,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService,
        private navCtrl: NavController,
        private router: Router,
        private alertCtrl: AlertController,
        private toast: ToastService,
        private platformService: Platform,
        @Inject(LOCALE_ID) private locale: string,
    ) {
        this.environment = environment;
        this.platform = this.authService.appMobile ? 'mobile' : 'website';

        this.subscriptions.push(
            this.event.subscribe('login', () => {
                this.coachValid = false;
            })
        );
        this.subscriptions.push(
            this.event.subscribe('logout', () => (this.coachValid = false))
        );

        this.template_coach_id = Number(this.activatedRoute.snapshot.paramMap.get('coachId'));
        this.template_title_id = Number(this.activatedRoute.snapshot.paramMap.get('titleId'));

        if (this.template_coach_id <= 0) {
            this.goBack();
        }
    }

    ngOnInit(): void {
    }

    ionViewWillEnter() {
        if (this.coach === null || !this.coachValid) {
            this.coachPromise = this.coachService.getCoach(this.template_coach_id);
        }

        if (this.availability === null || !this.availabilityValid) {
            this.availabilityPromise = this.coachService.getCoachAvailabilityList(
                this.template_coach_id,
                this.currentRange.startTime.toISOString(),
                this.currentRange.endTime.toISOString()
            );
        }
    }

    ionViewDidEnter() {
        this.analytics.trackView('Coach Calendar');

        if (this.coach === null || !this.coachValid) {
            this.coachPromise.then((data) => {
                this.coach = data;
                if (this.template_title_id) {
                    this.selectedTitle = this.coach.session_titles.find((item) => item.id === this.template_title_id);
                    if (this.selectedTitle) {
                        this.slotsCount = this.selectedTitle.slots;
                    }
                }
                this.initForm();
                console.log('getCoach', data)
                this.coachValid = true;
            });
        }

        setTimeout(() => {
            if (this.availability === null || !this.availabilityValid) {
                this.availabilityPromise.then((data) => {
                    this.availability = data;
                    this.getEvents();
                    this.availabilityValid = true;
                });
            }
        }, 0);
    }

    updateAvailability() {
        if (this.profileForm) {
            if (this.profileForm.value.title) {
                this.slotsCount = this.profileForm.value.title.slots;
            }
            this.coachService.getCoachAvailabilityList(
                this.template_coach_id,
                this.currentRange.startTime.toISOString(),
                this.currentRange.endTime.toISOString()
            ).then((data) => {
                this.availability = data;
                this.getEvents();
                this.availabilityValid = true;
                this.modalCount = 0;
            });
        }
    }

    getEvents() {
        const now = (new Date()).getTime()
        this.eventSource = this.availability.map((item) => {
            let startTime = new Date(item.start_at);
            startTime.setSeconds(0, 0);

            let endTime = this.addMinToDate(new Date(item.start_at), item.duration * this.slotsCount);
            endTime.setSeconds(0, 0);

            return this.returnEventElement(
                item.status !== 'available' || now > startTime.getTime(),
                startTime, endTime, item);
        });
    }

    returnEventElement(disabled, startTime, endTime, item) {
        return {
            title: `${this.addZero(startTime.getHours())}:${this.addZero(startTime.getMinutes())} - ${this.addZero(endTime.getHours())}:${this.addZero(endTime.getMinutes())}`,
            startTime: startTime,
            endTime: endTime,
            disabled: disabled,
            selected: true,
            allDay: false,
            model: item,
        };
    }

    goBack() {
        this.navCtrl.back();
    }

    next() {
        this.lockSwipes = false;
        setTimeout(() => {
            this.myCal.slideNext();
        });
    }

    back() {
        if (!this.lockSwipeToPrev) {
            this.lockSwipes = false;
            setTimeout(() => {
                this.myCal.slidePrev();
            });
        }
    }

    onViewTitleChanged(title) {
      console.log('onViewTitleChanged', title);

        this.viewTitle = title;
        this.currentMonth = new Date(title).getMonth() + 1;
        this.currentYear = new Date(title).getFullYear();

        this.lockSwipes = true;
        this.lockSwipeToPrev = (this.currentMonth <= new Date().getMonth() + 1 && this.currentYear <= new Date().getFullYear());
    }

    onRangeChanged(range) {
        console.log('onRangeChanged', range);
        this.currentRange = range;
        if (this.coach !== null) {
            this.updateAvailability();
        }
    }

    onTimeSelected = (ev: { selectedTime: Date; events: any[] }) => {
        this.currentDateEvent = [];
        this.selectedDate = ev.selectedTime;
        ev.events.forEach((item1) => {
            let time1 = new Date(item1.startTime);
            for (let i = 1; i < this.slotsCount; i++) {
                time1 = this.addMinToDate(time1, 30);
                if (!this.availability.find((item) => {
                    return new Date(item.start_at).getTime() === time1.getTime() && item.status === 'available';
                })) {
                    item1.disabled = true;
                }
            }
            this.currentDateEvent.push(item1);
        });

        this.pickedTime = null;
        this.confirmedTime = null;

        if (this.modalCount && this.currentDateEvent.length && window.innerWidth <= 719) {
            if (!this.profileForm.value.title) {
                this.toast.create('warning', '__TOAST_CALENDAR_SESSION_TITLE_IS_NOT_CHOSEN__');
            } else {
                this.modalIsVisible = true;
            }
        }
        ++this.modalCount;
    };

    closeModal() {
        this.modalIsVisible = false;
        this.pickedTime = null;
        this.confirmedTime = null;
    }

    chosenTime(ts) {
        this.pickedTime = ts;
    }

    confirmTime() {
        this.modalIsVisible = false;
    }

    initForm() {
        this.profileForm = new FormGroup({
            title: new FormControl(null,  Validators.required),
            type: new FormControl(null, Validators.required),
        });

        setTimeout(() => {
            this.profileForm.controls['title'].setValue(this.selectedTitle);
            this.profileForm.controls['type'].setValue(this.selectedType);
        })
    }

    onSubmit() {
        if (this.profileForm.status !== 'VALID') {
            this.alertCtrl
                .create({
                    header: this.translate.instant('__ALERT_ERROR_TITLE__'),
                    message: this.translate.instant(
                        '__ALERT_ERROR_MESSAGE_REQUIRED_FIELDS__'
                    ),
                    buttons: [this.translate.instant('__ALERT_ERROR_BUTTON__')],
                })
                .then((a) => a.present());
        } else {
            this.coachService
                .addCoachAppointment(
                    this.pickedTime.model.id,
                    this.profileForm.value.title.id,
                    this.profileForm.value.type
                )
                .then((data) => {
                    if (data && data.hasOwnProperty('status')) {
                        const bookedTime = this.currentDateEvent.find((elem) => this.pickedTime.model.id === elem.model.id);
                        if (bookedTime) {
                            bookedTime.disabled = true;
                        }
                        this.pickedTime = null;

                        this.toast.create('success', '__TOAST_REQUEST_SENT__');
                    } else {
                        this.alertCtrl
                            .create({
                                header: this.translate.instant('__ALERT_ERROR_TITLE__'),
                                message: this.translate.instant('__ALERT_TIME_IS_ALREADY_CHOOSE__'),
                                buttons: [this.translate.instant('__ALERT_ERROR_BUTTON__')],
                            })
                            .then((a) => a.present());
                    }
                });
        }
    }

    addZero(n) {
        if (`${n}`.length === 1) {
            n = `0${n}`;
        }
        return n;
    }

    timeArraySort(events) {
        events.sort(function(a, b) {
            if (a.start_at < b.start_at) {
                return -1;
            }
            if (a.start_at > b.start_at) {
                return 1;
            }
        });
        return events;
    }

    addMinToDate(date, minutes) {
        date.setMinutes(date.getMinutes() + minutes);
        return date;
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((i) => i.unsubscribe());
    }
}
